export default __webpack_public_path__ + "static/media/logo-guardiao-2-h.94632db3.png";